import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ROW_SEL = "tr, li, [data-testid*='row'], [data-testid*='card'], [data-testid*='paziente'], [data-testid*='cols']";

// Con ?focus=<id> nell'URL: scorre fino alla riga dell'elemento e la evidenzia.
export const OspiteFocus = () => {
  const { search, pathname } = useLocation();
  useEffect(() => {
    const id = new URLSearchParams(search).get("focus");
    if (!id) { return undefined; }
    let tries = 0;
    let done = false;
    const t = setInterval(() => {
      tries += 1;
      const hits = [...document.querySelectorAll(`main [data-testid$="-${CSS.escape(id)}"]`)].filter((e) => e.offsetParent !== null);
      const hit = hits.find((h) => hits.every((o) => o === h || h.contains(o))) || hits[0];
      if (!hit && tries < 40) { return; }
      clearInterval(t);
      if (!hit || done) { return; }
      done = true;
      const row = hit.closest(ROW_SEL) || hit;
      row.scrollIntoView({ behavior: "smooth", block: "center" });
      const prev = row.style.boxShadow;
      row.style.transition = "box-shadow .3s ease";
      row.style.boxShadow = "0 0 0 3px #f59e0b, 0 0 0 7px rgba(245,158,11,.25)";
      row.setAttribute("data-focus-ospite", "1");
      setTimeout(() => { row.style.boxShadow = prev; row.removeAttribute("data-focus-ospite"); }, 4500);
    }, 200);
    return () => clearInterval(t);
  }, [search, pathname]);
  return null;
};
